import { useTranslation } from "react-i18next";

export function LanguageSwitcher(): JSX.Element {
  const { i18n } = useTranslation();
  return (
    <select
      value={i18n.language.startsWith("en") ? "en" : "de"}
      onChange={(e) => void i18n.changeLanguage(e.target.value)}
      aria-label="language"
    >
      <option value="de">DE</option>
      <option value="en">EN</option>
    </select>
  );
}
